export default function getResource(label, vars = []) {
    const resources = {
        selectedProduct: `Article sélectionné : ${vars[0]}`,
        emptySlot: 'Emplacement vide',
        compareProducts: 'Comparer les articles',
        of: 'de',
        minimize: 'Minimiser',
        maximize: 'Maximiser',
        clearAll: 'Tout réinitialiser',
        compare: 'Comparer',
        removeProduct: 'Retirer l’article'
    };

    return resources[label];
}
